import axiosInstance from "utils/axios";

/**
 * Look up the recommended State + PostalCode for a Suburb, based on previously
 * saved Job locations. Returns null when the suburb is unknown — this is an
 * expected, non-error outcome, not a failure.
 * @param {string} suburb - Exact suburb text to look up
 * @returns {Promise<Object>} Response object with success, data ({suburb, state, postalCode} or null), and optional error
 */
export const getSuburbRecommendation = async (suburb) => {
  if (!suburb || !suburb.trim()) {
    return { success: true, data: null };
  }

  try {
    const response = await axiosInstance.get("api/Location/Suburb/Recommendation", {
      params: { suburb },
      showLoader: false,
    });

    if (!response.data) {
      return { success: true, data: null };
    }

    return {
      success: true,
      data: {
        suburb: response.data.suburb ?? response.data.Suburb,
        state: response.data.state ?? response.data.State,
        postalCode: response.data.postalCode ?? response.data.PostalCode,
      },
    };
  } catch (error) {
    // Never block the form over a failed recommendation lookup — manual entry
    // must always remain available.
    console.error("Error in getSuburbRecommendation:", error);
    return {
      success: false,
      data: null,
      error: error.message || "Failed to fetch location recommendation",
    };
  }
};
